module.exports = "/images/line-top-right-bottom-left.svg?570688a737a070a1ed59fbf0ac51d671";